import { defineStore } from "pinia";

import { User, UserRole, getCurrentUser } from "@/services/user";
import * as authService from "@/services/auth";

type UserStore = {
  user: User | null;
};

const extractTenantFromGroups = (groups: string[]) => {
  const prefix = "/tenants/";
  return groups.find(g => g.startsWith(prefix))?.replace(prefix, "") ?? "";
};

export const useUserStore = defineStore("user", {
  state: (): UserStore => ({
    user: null,
  }),
  getters: {
    isElevatedUser(state) {
      return (state.user?.roleId === UserRole.ADMIN || state.user?.roleId === UserRole.ENGINEER);
    },
    isEngineer(state) {
      return (state.user?.roleId === UserRole.ENGINEER);
    },
    isAdmin(state) {
      return (state.user?.roleId === UserRole.ADMIN);
    },
  },
  actions: {
    async fetchUser() {
      const user = await getCurrentUser();
      const authorizedUserInfo = await authService.getCurrentUser();
      this.user = {
        ...user,
        subjectId: authorizedUserInfo?.profile.sub ?? "",
        tenant: extractTenantFromGroups(authorizedUserInfo?.profile.groups ?? []),
      };
      return this.user;
    },
  },
});
